import React from 'react';
import { Box } from '@mui/material';

interface TotalCountBadgeProps {
  count?: number;
}

/** Small neutral pill showing a total record count, meant to sit next to a page title. */
const TotalCountBadge: React.FC<TotalCountBadgeProps> = ({ count }) => (
  <Box
    component="span"
    sx={{
      ml: 1,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 24,
      height: 22,
      px: 1,
      borderRadius: 999,
      bgcolor: 'background.grey',
      color: 'text.darkGrey',
      fontSize: (theme: any) => theme.typography.fontSizes.small,
      fontWeight: 600,
      verticalAlign: 'middle',
    }}
  >
    {count ?? 0}
  </Box>
);

export default TotalCountBadge;
